<div class="admissions-accelerators-teams-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="[]"></grid-content>
</div>